import { render, staticRenderFns } from "./AgreementInfo.vue?vue&type=template&id=f590c05a&"
import script from "./AgreementInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AgreementInfo.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f590c05a')) {
      api.createRecord('f590c05a', component.options)
    } else {
      api.reload('f590c05a', component.options)
    }
    module.hot.accept("./AgreementInfo.vue?vue&type=template&id=f590c05a&", function () {
      api.rerender('f590c05a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubPendingPayment/components/AgreementInfo.vue"
export default component.exports